import { useMemo } from "react";
import { Outlet, useParams } from "react-router-dom";
import Box from "@mui/material/Box";

import TopBar from "./TopBar";
import { restoreActiveEnvironment } from "../../utils/environment";

export default function DashboardLayout() {
    // React Router hands a layout the params of the whole matched branch, so
    // the workspace id from the child route is available here.
    const { workspaceId } = useParams();

    // Restore during render, not in an effect: the routed page fires its first
    // fetch from its own effect, and by then the axios interceptor already has
    // to know which environment to stamp. Restoring later would make the first
    // paint after a switch read production.
    useMemo(
        () => (workspaceId ? restoreActiveEnvironment(workspaceId) : null),
        [workspaceId],
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh' }}>
            <TopBar />
            <Box
                component="main"
                sx={{
                    width: '100%',
                    flexGrow: 1,
                    marginTop: '70px',
                    p: { xs: 2, sm: 4, md: 6 },
                    transition: 'all 0.3s ease-in-out',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
}
